import styled from "@emotion/styled";
import { MDSPopover } from "../popover/popover";

export const StyledMDSPopover = styled(MDSPopover)`
  padding: 0;
  background-color: transparent;
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.surface.preview};
  padding: 0;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  overflow: hidden;
`;

export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["3"]};
  background: ${({ theme }) => theme.colors.surface.previewHeader};
`;

export const StyledContent = styled.div``;
